import { usePromo } from '@entities/promo-video';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PromoEditorMenu, PromoHead } from '@widgets/promo-videos';
import { usePromoLoader } from '@features/promo-videos';
import { ArrowShortLeft } from '@shared/assets';
import { useMobile } from '@shared/hooks';
import {
  AspectRatioContent,
  Card,
  IconButton,
  ListBody,
  PageHead,
  PageTitle,
  Player,
} from '@shared/ui';
import * as st from './styles.module.scss';

export const Promo = ({ editorFormData }: { editorFormData?: any }): JSX.Element => {
  const navigate = useNavigate();
  const { videoId } = useParams<{ code: string; videoId: string; id: string }>();
  const promoId = Number(videoId);

  usePromoLoader(promoId);
  const { promo } = usePromo(promoId);

  const onClose = () => navigate(-1);

  const { isMobile } = useMobile();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderDesktopContent = () => (
    <div className={st.video}>
      <PromoHead videoId={videoId as any} />
      <Card className={st.video__tab}>
        {promo && (
          <AspectRatioContent>
            <Player video={promo} />
          </AspectRatioContent>
        )}
      </Card>
    </div>
  );

  const renderMobileContent = () => {
    if (!promo) {
      return null;
    }

    return (
      <div className={st.video}>
        <div className={st.block}>{<Player video={promo} />}</div>
        <div className={st.content}>
          {promo.title && <div className={st.content__title}>{promo.title}</div>}
        </div>
      </div>
    );
  };

  return (
    <>
      <PageTitle title={'Трейлер'} />

      <PageHead
        Left={
          <IconButton variant="dark" onClick={onClose}>
            <ArrowShortLeft />
          </IconButton>
        }
        Right={<PromoEditorMenu videoId={promoId} editorFormData={editorFormData} />}
      />

      <ListBody>{!isMobile ? renderDesktopContent() : renderMobileContent()}</ListBody>
    </>
  );
};
